import React from 'react'
import { normalizeProps } from './utils/normalizeProps'

const RedirectIcon = props => {
  return (
    <svg
      width='12'
      height='13'
      viewBox='0 0 12 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...normalizeProps(props)}
    >
      <path
        d='M2.75 1.84863C2.05964 1.84863 1.5 2.40828 1.5 3.09863V9.59863C1.5 10.289 2.05964 10.8486 2.75 10.8486H9.25C9.94036 10.8486 10.5 10.289 10.5 9.59863V8.09863C10.5 7.68442 10.8358 7.34863 11.25 7.34863C11.6642 7.34863 12 7.68442 12 8.09863V9.59863C12 11.1174 10.7688 12.3486 9.25 12.3486H2.75C1.23122 12.3486 0 11.1174 0 9.59863V3.09863C0 1.57985 1.23122 0.348633 2.75 0.348633H4.25C4.66421 0.348633 5 0.684419 5 1.09863C5 1.51285 4.66421 1.84863 4.25 1.84863H2.75ZM5.99976 1.09863C5.99976 0.684419 6.33554 0.348633 6.74976 0.348633H11.2498C11.664 0.348633 11.9998 0.684419 11.9998 1.09863V5.59863C11.9998 6.01285 11.664 6.34863 11.2498 6.34863C10.8355 6.34863 10.4998 6.01285 10.4998 5.59863V2.90958L7.28008 6.1292C6.98719 6.42209 6.51231 6.42208 6.21942 6.12919C5.92653 5.83629 5.92653 5.36142 6.21943 5.06853L9.43938 1.84863H6.74976C6.33554 1.84863 5.99976 1.51285 5.99976 1.09863Z'
        fill='#5F6368'
      />
    </svg>
  )
}

export default RedirectIcon
